import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { RepairsForm } from '@modules/repairs/RepairsForm';
import { ActionBar } from '@modules/repairs/RepairsGridButtons';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const repairsUrl = '/metropolis/api/cl/repair';
export const repairsLabel = 'Opravy';
export const repairsPath = '/repairs';
export const repairsGridName = 'RepairsGrid';
export const RepairsGrid = compose(
  withRouter,
  setDisplayName(repairsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: repairsLabel }]),
  withColumns(Agenda.REPAIRS),
  withProps(({ history, columns }) => ({
    name: repairsGridName,
    url: repairsUrl,
    Form: RepairsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      history,
      ActionBar,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: false,
      pageSize: 50,
      version: 3
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/repairs/RepairsGrid.tsx